import {
  ACCOUNT_INVESTMENT_OBJECTIVES_GET,
  PORTFOLIO_PROPOSALS_KPIS_GET,
  PORTFOLIO_PROPOSALS_HOLDINGS_GET,
  PORTFOLIO_PROPOSALS_DETAILS_GET,
  PORTFOLIO_PROPOSALS_BENCHMARK_GET,
  PORTFOLIO_PROPOSALS_MAX_DRAWDOWN_GET,
  INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_GET,
  INVESTMENT_OBJECTIVE_GET,
  PORTFOLIOS_HOLDINGS_GET,
  PORTFOLIOS_DETAILS_GET,
  PORTFOLIOS_BENCHMARK_GET,
  PORTFOLIOS_KPIS_GET,
} from '../actions/types';

const initialState = {
  items: {}, // [accountId]: investmentObjectives
  // proposals
  portfolioProposals: {}, // [investmentObjectiveId]: portfolioProposals
  portfolioProposalKpis: {}, // [proposalId]: kpis
  portfolioProposalHoldings: {}, // [proposalId]: holdings
  portfolioProposalRiskProfile: {}, // [proposalId]: holdings
  portfolioProposalSectorAllocation: {}, // [proposalId]: allocation (details)
  portfolioProposalGeoAllocation: {}, // [proposalId]: allocation (details)
  portfolioProposalAssetClassAllocation: {}, // [proposalId]: allocation (details)
  portfolioProposalCurrencies: {}, // [proposalId]: currencies (details)
  portfolioProposalOptimized: {}, // [proposalId]: optimization
  portfolioProposalMaxDrawdowns: {}, // [proposalId]: maxDrawdown
  portfolioProposalPerformances: {}, // [proposalId]: performance/benchmark
  portfolioProposalForecasts: {}, // [proposalId]: forecast
  portfolioProposalRecommendations: {}, // [proposalId]: recommendation
  // portfolios
  portfolios: {}, // [investmentObjectiveId]: portfolio
  portfolioHoldings: {}, // [portfolioId]: holdings
  portfolioSectorAllocation: {}, // [portfolioId]: allocation (details)
  portfolioGeoAllocation: {}, // [portfolioId]: allocation (details)
  portfolioAssetClassAllocation: {}, // [portfolioId]: allocation (details)
  portfolioCurrencies: {}, // [portfolioId]: currencies
  portfolioPerformances: {}, // [portfolioId]: performance/benchmark
  portfolioKpis: {}, // [portfolioId]: kpis
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_INVESTMENT_OBJECTIVES_GET._SUCCESS: {
      const { accountId, investmentObjectives } = action.payload;
      state.items[accountId] = investmentObjectives;
      return state;
    }
    case INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_GET._SUCCESS: {
      action.payload.forEach(({ id, portfolioProposals }) => {
        state.portfolioProposals[id] = portfolioProposals;
      });
      return state;
    }
    case INVESTMENT_OBJECTIVE_GET._SUCCESS: {
      action.payload.forEach(({ id, investmentObjective }) => {
        const { portfolioProposals, portfolio, ...newObj } = investmentObjective;
        state.portfolioProposals[id] = portfolioProposals;
        state.portfolios[id] = portfolio;

        // update investment objective values
        const objs = state.items[investmentObjective.accountId];
        const filteredObjs = objs.filter((o) => o.id !== investmentObjective.id);
        state.items[investmentObjective.accountId] = [...filteredObjs, newObj];
      });
      return state;
    }
    case PORTFOLIO_PROPOSALS_KPIS_GET._SUCCESS: {
      action.payload.forEach(({ id, kpis }) => {
        state.portfolioProposalKpis[id] = kpis;
        state.portfolioProposalKpis[id] = kpis;
      });
      return state;
    }
    case PORTFOLIO_PROPOSALS_HOLDINGS_GET._SUCCESS: {
      const { proposalId, proposalHoldings, riskProfile } = action.payload;
      state.portfolioProposalHoldings[proposalId] = proposalHoldings;
      state.portfolioProposalRiskProfile[proposalId] = riskProfile;
      return state;
    }
    case PORTFOLIO_PROPOSALS_DETAILS_GET._SUCCESS: {
      const { proposalId, portfolioProposal } = action.payload;
      state.portfolioProposalSectorAllocation[proposalId] = portfolioProposal.sectorAllocation;
      state.portfolioProposalGeoAllocation[proposalId] = portfolioProposal.geoAllocation;
      state.portfolioProposalAssetClassAllocation[proposalId] =
        portfolioProposal.assetClassAllocation;
      state.portfolioProposalCurrencies[proposalId] = portfolioProposal.currencies;
      return state;
    }
    case PORTFOLIO_PROPOSALS_BENCHMARK_GET._SUCCESS: {
      const {
        proposalId,
        performanceChartYearsTag,
        performanceChartBenchmarkId,
        performanceChart,
        compareIds,
      } = action.payload;
      if (compareIds) {
        state.portfolioProposalPerformances[proposalId] = {
          comparisons: {
            [compareIds]: {
              performanceChartBenchmarkId,
              performanceChart,
              performanceChartYearsTag,
            },
          },
        };
      } else {
        state.portfolioProposalPerformances[proposalId] = {
          performanceChartYearsTag,
          performanceChartBenchmarkId,
          performanceChart,
        };
      }
      return state;
    }
    case PORTFOLIO_PROPOSALS_MAX_DRAWDOWN_GET._SUCCESS: {
      const { proposalId, maxDrawdown } = action.payload;
      state.portfolioProposalMaxDrawdowns[proposalId] = maxDrawdown;
      return state;
    }
    case PORTFOLIOS_HOLDINGS_GET._SUCCESS: {
      const { portfolioId, portfolioHoldings } = action.payload;
      state.portfolioHoldings[portfolioId] = portfolioHoldings;
      return state;
    }
    case PORTFOLIOS_DETAILS_GET._SUCCESS: {
      const { portfolioId, portfolio } = action.payload;
      state.portfolioSectorAllocation[portfolioId] = portfolio.sectorAllocation;
      state.portfolioGeoAllocation[portfolioId] = portfolio.geoAllocation;
      state.portfolioAssetClassAllocation[portfolioId] = portfolio.assetClassAllocation;
      state.portfolioCurrencies[portfolioId] = portfolio.currencies;
      return state;
    }
    case PORTFOLIOS_BENCHMARK_GET._SUCCESS: {
      const {
        portfolioId,
        performanceChartYearsTag,
        performanceChartBenchmarkId,
        performanceChart,
      } = action.payload;
      state.portfolioPerformances[portfolioId] = {
        performanceChartYearsTag,
        performanceChartBenchmarkId,
        performanceChart,
      };
      return state;
    }
    case PORTFOLIOS_KPIS_GET._SUCCESS: {
      const { portfolioId, kpis } = action.payload;
      state.portfolioKpis[portfolioId] = {
        kpis,
      };

      return state;
    }
    default:
      return state;
  }
};

export { reducer as investmentObjectives };
